import Header from './header'
import Projects from './projects'
import Contacts from './contacts'
import MainMenu from './main-menu'

import '../scss/index.scss'

// Import to make available in dist folder.
import '../images/cms/login-bg.jpg'
import '../images/cms/login-logo.svg'
import '../images/svg/icons.svg'
import '../images/svg/avatar.svg'
import '../images/svg/checkmark.svg'
import '../images/svg/chevron-down.svg'

Header.init()
Projects.init()
Contacts.init()
MainMenu.init()
